import axios from 'axios'
import router from '@/router'
import store from '@/store'
import {storageData} from "@/assets/js/storage";

const service = axios.create({
  // baseURL: window.location.origin,
  timeout: 180000,
  /*headers: {
    'Cache-Control': 'no-cache'
  }*/
});

let pending = []; //用于存储每个ajax请求的标识和取消函数
let cancelToken = axios.CancelToken;
let whiteCancelList = ['/api/main/heartbeat.json','/api/statistical/class_log_statistical.json', '/api/statistical/user_statistical_organ.json', '/api/statistical/class_log_statistical_organ.json', '/api/statistical/plan_statistical_organ.json', '/api/statistical/class_statistical_organ.json'  ]; // 避免请求被cancel
let removePending = (config) => {
  for(let item in pending){
    if(config.method.toUpperCase() === "POST") {
      if (pending[item].flag === `${config.url}&${config.method}&${config.data}`) {
        pending[item].cancel(); //执行取消操作
        pending.splice(item, 1); //把这条记录从数组中移除
      }
    }
    if(config.method.toUpperCase() === "GET"){
      // 避免心跳请求和大屏数据请求被取消
      // if(`${config.url}` !== '/api/main/heartbeat.json' && `${config.url}` !== '/api/statistical/class_log_statistical.json') {
      if(!whiteCancelList.includes(`${config.url}`)) {
        if (pending[item].flag === `${config.url}&${config.method}&${config.params}`) {
          pending[item].cancel(); //执行取消操作
          pending.splice(item, 1); //把这条记录从数组中移除
        }
      }
    }
  }
};
const pathArr = ["/student/create_tutorial", "/student/edit_tutorial","/teacher/create_tutorial","/teacher/create_tutorial"];

/* 请求拦截器 */
service.interceptors.request.use((config) => {
  const token = storageData.getToken();
  const defaultToken=yioks_vm.$options.token
  if (token) {
    config.headers["X-Token"] = token;
  }
  /* 取userType */
  const userType = storageData.getUserType();
  if (userType) {
    config.headers["X-UserType"] = userType;
  }
  if (config.url.indexOf('/api/index') !==-1){
    return config
  }
  if (token && defaultToken && (token !==defaultToken) && !pathArr.includes(router.history.current.path)){
    store.commit('updateIsLogin',true)
    return
  }
  removePending(config);
  config.cancelToken = new cancelToken((cancel)=>{

    if(config.method.toUpperCase() === "POST") {
      /*console.log("POST");
      console.log(config.data);*/
      // ajax标识: 请求地址&请求方式拼接的字符串
      pending.push({ flag: `${config.url}&${config.method}&${config.data}`, cancel: cancel });
    }
    if(config.method.toUpperCase() === "GET"){
      /*console.log("GET");
      console.log(config.params);*/
      // ajax标识: 请求地址&请求方式拼接的字符串
      pending.push({ flag: `${config.url}&${config.method}&${config.params}`, cancel: cancel });
    }
  });
  return config;
}, (err) => {
  console.error('请求发生了错误', err);
  return Promise.reject(err);
});


/* 响应拦截器 */
service.interceptors.response.use((res) => {
  const {status} = res.data;
  if (Number(status) === 1) {
    const path = router.history.current.path;
    if(!pathArr.includes(path)) {
      storageData.clearToken();
      storageData.clearUserInfo();
      router.replace("/login");
    }
  }
  if (Number(status) === 2) {
    const path = router.history.current.path;
    if(!pathArr.includes(path)) {
      storageData.clearToken();
      storageData.clearUserInfo();
      storageData.clearUserType();
      // console.log(123);
      router.replace("/login");
      // 暂时隐藏直接返回登录
      /*store.commit("setRepeatLogin", {
        flag: true,
        msg: res.data.msg.replace(/[,，]/g, "<br>")
      });*/
    }
  }
  /* 没有权限 */
  if(Number(status) >= 30000 && Number(status) <= 40000) {
    router.replace({
      path: "/permission/forbid",
      query: {
        // 汉字转码
        msg: encodeURIComponent(res.data.msg)
      },
    });
  }
  removePending(res.config);  // 把已经完成的请求从pending中移除
  return res;
}, (err) => {
  yioks_vm.$message({
    type: "error",
    message: "网络无法链接,请检测网络设置~"
  });
  console.error('响应发生了错误', err);
  return Promise.reject(err);
});

export default service
